import { z } from 'zod';

// Workspace-wide Einzugsgebiet coverage (IMM-415): every Standort of the key's
// workspace with its assigned PLZs, read through the authenticated coverage API.
// Distinct from the org-addressed per-Standort endpoints in
// `coverage-postal-codes.schemas.ts`. Machine-facing tokens are stable English:
// `type` is `main`/`sub` and `status` is `active`/`inactive` (mapped from the
// internal `main`/`subsidiary` and `ACTIVE`/`INACTIVE`), and the Standort list
// rides under `locations` — never the German `standorte`.

export const WorkspaceCoveragePathParamsSchema = z.object({
  workspaceId: z.uuid(),
});

export const CoverageLocationSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  type: z.enum(['main', 'sub']),
  status: z.enum(['active', 'inactive']),
  parentId: z.uuid().nullable(),
  postalCodes: z.array(z.string()),
});

export type CoverageLocation = z.infer<typeof CoverageLocationSchema>;

export const WorkspaceCoverageResponseSchema = z.object({
  workspace: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  generatedAt: z.string(),
  locations: z.array(CoverageLocationSchema),
});

export type WorkspaceCoverageResponse = z.infer<typeof WorkspaceCoverageResponseSchema>;
